import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    marker:
      'absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 cursor-pointer rounded-full',
    markerInner: 'block size-12 rounded-full border border-white bg-black'
  },
  variants: {
    isSelected: {
      true: {
        marker: 'border-4 border-white',
        markerInner: 'bg-accent border-surface relative h-16 w-16 border-[1px]'
      }
    },
    type: {
      default: {},
      shops: {
        markerInner:
          'before:absolute before:top-0 before:left-1/2 before:h-full before:w-[74%] before:-translate-x-1/2 before:bg-[url("/api/media/file/logo-icon-light.svg")] before:bg-contain before:bg-center before:bg-no-repeat'
      }
    }
  }
});
